// src/components/pages/BusinessPage.js
// 다른 메뉴(Expertise/Solution/Home)와 동일한 레이아웃: 이미지 풀와이드 → 검은 배경 설명 블록 → 카드
import React from 'react';
import { Box, Grid, Typography, Button } from '@mui/material';
import HeroBanner from '../common/HeroBanner';
import DescriptionBlock from '../common/DescriptionBlock';

const InfoCard = ({ title, description, accent }) => (
  <Box
    sx={{
      backgroundColor: '#111827',
      borderLeft: `3px solid ${accent}`,
      borderRadius: '8px',
      p: 3,
      height: '100%'
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 600, color: 'white', mb: 1 }}>
      {title}
    </Typography>
    <Typography variant="body2" sx={{ color: '#D1D5DB', lineHeight: 1.7 }}>
      {description}
    </Typography>
  </Box>
);

const BusinessPage = ({ onContactClick }) => {
  return (
    <Box sx={{ width: '100%' }}>
      {/* 메인 이미지 - 자르지 않고 원본 그대로, 텍스트 오버레이 없음 */}
      <HeroBanner image="/images/business-collaboration.png" overlay={false} />

      {/* 검은 배경 설명 블록 */}
      <DescriptionBlock
        title="Business Collaboration"
        paragraphs={[
          'A partnership platform for commercializing bold ideas across energy, AI, and agriculture.'
        ]}
      />

      {/* 파트너십 기회 / 제공 서비스 카드 */}
      <Box sx={{ p: { xs: 3, md: 5 }, backgroundColor: '#0f172a' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <InfoCard
              title="Partnership Opportunities"
              description="Commercializing challenging ideas to create joint business opportunities (Energy, AI, Agriculture, and more)."
              accent="#3b82f6"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoCard
              title="Services Provided"
              description="Idea commercialization collaboration."
              accent="#16a34a"
            />
          </Grid>
        </Grid>

        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Button
            onClick={onContactClick}
            variant="contained"
            sx={{
              backgroundColor: '#16a34a',
              fontWeight: 'bold',
              fontSize: '1rem',
              px: 5,
              py: 1.5,
              borderRadius: '9999px',
              '&:hover': { backgroundColor: '#15803d' }
            }}
          >
            Contact for Partnership
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default BusinessPage;
